import React, { Component } from 'react'
import styled from 'styled-components'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'

import scrollOnMount from 'utils/scrollOnMount'
import withPost from 'containers/withPost'
import withSiteMeta from 'containers/withSiteMeta'
import Modules from 'ui/components/Modules'
import Seo from 'ui/components/Seo'

const Wrapper = styled.div`
  min-height: calc(100vh - ${props => props.theme.navHeight}px);
`;


class NotFound extends Component {

  render() {
    const { post, loading, type } = this.props

    return (
      <Wrapper>
        {!loading &&
          <div>
            <Seo seo={post.seo} />
          </div>
        }

        {!loading && post.modules &&
          <Modules modules={post.modules} post={post} type={type} />
        }
      </Wrapper>
    );
  }
}

export default compose(
  withRouter,
  scrollOnMount,
  withSiteMeta(),
  withPost(
    props => props.siteMeta.notFoundSlug,
    () => 'page', props => props.siteMeta.locale === props.siteMeta.defaultLanguage ? null : props.siteMeta.locale,
    () => <h1>Not found either..</h1>
  )
)(NotFound)



// WEBPACK FOOTER //
// ./src/ui/components/NotFound.js